import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Node from './Node';
import { isLastElementAttrEqual } from '../../helpers/array';

const NodeBox = ({ label, nodes }) => (
  <div className={cx('timeline__node-box', { colored: label })}>
    {label && <div className="timeline__node-box__label">{label}</div>}
    <div className="timeline__node-box__container">
      {nodes && nodes.map((node, index) => (
        <Fragment key={node.id}>
          <Node data={node} />
          {index < nodes.length - 1 && (
            <div
              className={cx('timeline__node-box__line', { solid: node.status === 'past' })}
            />
          )}
        </Fragment>
      ))}
      <div className={cx('timeline__line', { solid: isLastElementAttrEqual(nodes, 'status', 'past') })} />
    </div>
  </div>
);

Node.defaultProps = {
  data: [],
};

Node.propTypes = {
  label: PropTypes.string,
  nodes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.string,
    group: PropTypes.string,
  })),
};
export default NodeBox;
